import { Box } from '@mui/material';
import { motion } from 'framer-motion';

const MotionBox = motion(Box);

interface AnimatedBoxProps {
  children: React.ReactNode;
}

export const AnimatedBox = ({ children }: AnimatedBoxProps) => {
  return (
    <MotionBox
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      {children}
    </MotionBox>
  );
}; 